import Vue from 'vue';
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo,{
    duration:100,
    easing:"ease"
})

export default new Vue({
});
